// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyList-noDataIconSec-aAX9Z {
    width: 184px;
    height: 120px;
}

.EmptyList-noTransactionSectionSpace-cWA4e {
    margin-top: 66px;
    margin-bottom: 22px;
}

.EmptyList-noPayoutContentSection-GoXx0 {
    max-width: 580px;   
}

@media screen and (max-width:767px) {
    .EmptyList-noPayoutContentSection-GoXx0 {
        max-width: 100%
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Payout/PayoutList/EmptyList.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI;IACJ;AACJ","sourcesContent":[".noDataIconSec {\n    width: 184px;\n    height: 120px;\n}\n\n.noTransactionSectionSpace {\n    margin-top: 66px;\n    margin-bottom: 22px;\n}\n\n.noPayoutContentSection {\n    max-width: 580px;   \n}\n\n@media screen and (max-width:767px) {\n    .noPayoutContentSection {\n        max-width: 100%\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noDataIconSec": `EmptyList-noDataIconSec-aAX9Z`,
	"noTransactionSectionSpace": `EmptyList-noTransactionSectionSpace-cWA4e`,
	"noPayoutContentSection": `EmptyList-noPayoutContentSection-GoXx0`
};
module.exports = ___CSS_LOADER_EXPORT___;
